
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificate/[token]",
      function () {
        return require("private-next-pages/certificate/[token].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificate/[token]"])
      });
    }
  